module.exports = __webpack_public_path__ + "media/images/products/products/ed2-5754a4dd642ee2b52b7902984bce5509.jpg";